import options from "@/core/data/options";

const removeChar = (str, target) => {
  const re = new RegExp(target, "g");
  return str.replace(re, "");
};

const getMaterialLabel = (value) => {
  const materialObject = options.materialsAvailableOptions.find(
    (item) => item.value === value
  );
  return materialObject || { label: value, value: value };
};

const convertToCommaSeparatedListWithAnd = (list, currentString = "") => {
  if (!list.length) return currentString;

  if (list.length === 1) {
    const newValue = list.shift();
    return convertToCommaSeparatedListWithAnd(list, currentString + newValue);
  }

  if (list.length === 2) {
    const newValue = list.shift() + " and ";
    return convertToCommaSeparatedListWithAnd(list, currentString + newValue);
  }

  if (list.length > 2) {
    const newValue = list.shift() + ", ";
    return convertToCommaSeparatedListWithAnd(list, currentString + newValue);
  }
};

const getStringFromOptions = (includedValues, optionsList) => {
  if (!includedValues?.length) {
    return "";
  }
  const labelArray = includedValues.map((value) => {
    const matchObject = optionsList.find((item) => item.value === value);
    return matchObject?.label ? matchObject.label : "";
  });

  return convertToCommaSeparatedListWithAnd(labelArray);
};

const getCurrency = (line) => {
  const parts = line.trim().split(" ");
  return parts[0];
};

const getAmount = (line) => {
  const parts = line.trim().split(" ");
  if (parts.length === 3) {
    const amount = removeChar(parts[1], ",");
    return amount;
  }
  return "";
};

export {
  getMaterialLabel,
  convertToCommaSeparatedListWithAnd,
  getStringFromOptions,
  getAmount,
  getCurrency,
};
